import LanguageChanger from './LanguageChanger'

export default LanguageChanger
